import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {LocationDto} from '../model/continent';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  constructor(private httpClient: HttpClient) {}

  getCityList(params: PaginationParams, displayPageOnly?: boolean): Observable<Pagination<LocationDto>>  {
    const cleanParams = cleaningParams(params);
    let fullParams;
    if (displayPageOnly) {
      fullParams = { ...cleanParams, displayPageOnly: true }
    } else {
      fullParams = { ...cleanParams }
    }
    return this.httpClient.get<Pagination<LocationDto>>(`${environment.apiUrl}/public/city`,
      { params: { ...fullParams } });
  }

  getCity(id: number): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/city/${id}`);
  }

  getCityByUrl(url: string): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/city/by-url/${url}`);
  }

  getCityListByCountry(params: PaginationParams, id: number,  displayPageOnly?: boolean): Observable<Pagination<LocationDto>>  {
    const cleanParams = cleaningParams(params);
    let fullParams;
    if (displayPageOnly) {
      fullParams = { ...cleanParams, displayPageOnly: true }
    } else {
      fullParams = { ...cleanParams }
    }
    return this.httpClient.get<Pagination<LocationDto>>(`${environment.apiUrl}/public/city/by-country/${id}`,
      { params: { ...fullParams } });
  }

  moveUp(id: number): Observable<boolean>  {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/city/move-up/${id}`, id);

  }

  moveDown(id: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/city/move-down/${id}`, id);
  }

  saveCityPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city/file/${id}`, formData);
  }

  saveCityFooterPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city/footer/file/${id}`, formData);
  }

  saveCityCarousel(idCity: number, idCarousel: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city/file/${idCity}/${idCarousel}`, formData);
  }

  deleteCityCarousel(idCity: number, idCarousel: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/city/${idCity}/${idCarousel}`);
  }

  saveEventPhoto(idCity: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city/file/event/${idCity}/${eventId}`, formData);
  }

  deleteEventCity(idCity: number, eventId: number) {
    return this.httpClient.delete(`${environment.apiUrl}/city/event/${idCity}/${eventId}`);
  }

  saveAdditionalEventPhoto(idCity: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city/file/additional-event/${idCity}/${eventId}`, formData);
  }

  deleteAdditionalEvent(idCity: number, idCarousel: number,) {
    return this.httpClient.delete(`${environment.apiUrl}/city/additional-event/${idCity}/${idCarousel}`);
  }


  saveCity(City: LocationDto): Observable<LocationDto> {
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/city`, City);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/city/${id}`);
  }
}
